import api from "../config";
import URLS from "../../constants/urls";
export const _getAllVisitors = async (siteId, pageNumber = 0, pageSize = 10) => {
    const response = await api.get(`${URLS.VISITOR}/${siteId}?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.data;
};
